export const AppstoreBadge = () => {
  return (
    <a target="_blank" href="https://apps.apple.com/in/app/um-vvs-madhwa-matrimony/id6445883686" rel="external" style={{ color: "unset" }}>
      <img src="/images/apple_download_badge_black.svg" width="160px" alt="App store download badge" />
    </a>

  );
};
  